import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteContentArguments {
  params: OpalApiRequestParams<'DeleteContentV2'>
}

/**
 * Deletes a piece of content everywhere in Opal, and cannot be undone.
 *
 * The id is the content's `legacy_id`, not its UUID: `/content/v3` serves no
 * delete. The endpoint answers `202` with no body, so `null` stands in for it.
 */
export async function deleteContent({
  params,
}: DeleteContentArguments): Promise<null> {
  const url = new URL(
    `/content/v2/${params.path.content_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
